import { ActivatedRoute } from '@angular/router';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environment/environment';

@Component({
    selector: 'app-list-component',
    template: ''
})
export abstract class ListComponent {
    public environment = environment;
    public items: Observable<any[]> = new Observable();
    protected currentPage = 1;
    private readonly route: ActivatedRoute = inject(ActivatedRoute);

    public ngOnInit(): void {
        this.currentPage = this.route.snapshot.queryParams['page'];
    }
}
